// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__37ssB","list":"PatternAutocomplete_list__2o9_U"};